import { fetchWithTimeout } from "../../utils/fetchWithTimeout";
import {
  ScheduleClient,
  UpdateScheduleSlotCommand,
} from "../../web-api-client";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { makeFetchWithAuth } from "../../auth/authFetch";
import { useNavigate } from "react-router-dom";
import { appConfig } from "../../appconfig";

export function useUpdateSchedule() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (payload: { id: number; capacity: number; status: "O" | "C" }) => {
      const client = new ScheduleClient(appConfig.apiBaseUrl, {
        fetch: makeFetchWithAuth(fetchWithTimeout(), {
          onUnauthorized: () =>
            navigate("/login", {
              replace: true,
              state: { from: window.location.pathname },
            }),
        }),
      });

      const body = new UpdateScheduleSlotCommand();
      body.capacity = payload.capacity;
      body.status = payload.status;

      return client.updateScheduleSlot(payload.id, body);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["schedules"] });
    },
  });
}
